module.exports = __webpack_public_path__ + "static/media/torch.88e03af0.png";